import React from "react";
import { siteConfig, LOGO_URL } from "../../data/mockData";
import { useSiteData } from "../../context/SiteDataContext";
import { Send, ArrowUp } from "lucide-react";

const Footer = () => {
  const { socialLinks: sl, siteConfig: sc } = useSiteData();
  const socialLinks = sl || {};
  const logoUrl = sc?.logoUrl || LOGO_URL;
  const coinName = sc?.coinName || siteConfig.coinName;
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative bg-[#040804] border-t border-[#1a3a1a] pt-12 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-8">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img
              src={logoUrl}
              alt="Marsupilami Coin"
              className="w-12 h-12 rounded-full border-2 border-yellow-400"
            />
            <div>
              <h3 className="text-xl font-bold">
                <span className="text-yellow-400">MARSUPİ</span>
                <span className="text-white">LAMİ</span>
              </h3>
              <p className="text-gray-500 text-xs">HUBA HUBA!</p>
            </div>
          </div>

          {/* Nav Links */}
          <div className="flex flex-wrap justify-center gap-6">
            {[
              { label: "About", href: "#about" },
              { label: "Features", href: "#features" },
              { label: "Tokenomics", href: "#tokenomics" },
              { label: "Roadmap", href: "#roadmap" },
              { label: "FAQ", href: "#faq" },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-gray-400 hover:text-yellow-400 text-sm transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-3">
            <a
              href={socialLinks.telegram || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-yellow-400/10 border border-yellow-400/30 flex items-center justify-center text-yellow-400 hover:bg-yellow-400 hover:text-black transition-all duration-300"
            >
              <Send size={18} />
            </a>
            <a
              href={socialLinks.twitter || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-yellow-400/10 border border-yellow-400/30 flex items-center justify-center text-yellow-400 hover:bg-yellow-400 hover:text-black transition-all duration-300"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24h-2.19L17.61 20.644Z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#1a3a1a] to-transparent mb-6" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs">
            © 2025 {coinName} Coin. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs">
            Crypto investments involve risk. Do your own research.
          </p>
        </div>
      </div>

      {/* Scroll to top */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-6 right-6 w-10 h-10 rounded-full bg-yellow-400/20 border border-yellow-400/30 flex items-center justify-center text-yellow-400 hover:bg-yellow-400 hover:text-black transition-all duration-300 z-40"
      >
        <ArrowUp size={18} />
      </button>
    </footer>
  );
};

export default Footer;
